import type { Lang } from '@/api';
import { useLang } from '@/lang';

interface PenaltyItem {
  n: number;
  p: number;
  t: string;
  note?: string;
}

type PenaltyGroups = Record<'minor' | 'medium' | 'gross', PenaltyItem[]>;

const uzl = {
  srLoading: 'Yuklanmoqda',
  srClose: 'Yopish',
  srMainMenu: 'Asosiy menyu',
  srLang: 'Til',
  day: 'kun',
  drill: 'Xatolar ustida ishlash',
  start: 'Bugungi mashqni boshlash',
  next: 'Keyingi savol',
  finish: 'Yakunlash',
  keepGoing: 'Davom etish',
  correct: 'To‘g‘ri',
  wrong: 'Noto‘g‘ri',
  tabHome: 'Bosh',
  tabExam: 'Imtihon',
  topic: 'Mavzu',
  history: 'Oldingi urinishlar',
  triesUnit: 'urinish',
  bestOf: 'eng yaxshi',
  examStarting: 'Imtihon tayyorlanmoqda…',
  startExam: 'Imtihonni boshlash',
  submit: 'Yakunlash va topshirish',
  submitting: 'Yuborilmoqda…',
  submitFail: 'Yuborib bo‘lmadi. Aloqani tekshirib, qayta urinib ko‘ring.',
  timeLeft: 'Qolgan vaqt',
  result: 'Natija',
  retake: 'Qayta',
  noAnswer: 'Javobsiz',
  passed: 'O‘tdingiz!',
  failed: 'Bu safar o‘tmadingiz',
  ofTwenty: '{n} savoldan to‘g‘ri',
  review: 'Javoblarni ko‘rib chiqish',
  backToExam: 'Imtihonga qaytish',
  backToSaved: 'Saqlanganlarga qaytish',
  your: 'Sizning javobingiz:',
  right: 'To‘g‘ri javob:',
  r1: 'savol',
  pass: 'o‘tdi',
  fail: 'o‘tmadi',
  inProgress: 'davom etmoqda',
  months: [
    'yanvar',
    'fevral',
    'mart',
    'aprel',
    'may',
    'iyun',
    'iyul',
    'avgust',
    'sentabr',
    'oktabr',
    'noyabr',
    'dekabr',
  ],
  saved: 'Saqlangan savollar',
  savedUnit: 'ta savol',
  reviewSaved: 'Saqlanganlarni takrorlash',
  save: 'Saqlash',
  unsave: 'Saqlanganlardan olish',
  savedEmpty: 'Hozircha saqlangan savol yo‘q',
  savedEmptySub: 'Mashq paytida qiyin savolni belgilab qo‘ying — ular shu yerda to‘planadi.',
  back: 'Orqaga',
  zoom: 'Kattalashtirish',
  explainLink: 'O‘rganish',
  added: '«Xatolar»ga qo‘shildi',
  savol: 'Savol',
  offline: 'Internet yo‘q — ulanish tiklanishini kutyapmiz',
  saveFailed: 'Saqlab bo‘lmadi — aloqani tekshirib, qayta bosing',
  errTitle: 'Xatolik',
  errNetwork: 'Internet aloqasini tekshirib, qayta urinib ko‘ring.',
  errServer: 'Serverda nosozlik. Birozdan so‘ng qayta urinib ko‘ring.',
  errNotFound: 'Bu sahifa topilmadi.',
  errGeneric: 'Nimadir noto‘g‘ri ketdi. Qayta urinib ko‘ring.',
  noBilets: 'Biletlar hali yo‘q',
  answerUnsaved: 'Javob saqlanmadi — topshirganda yuboriladi',
  examTimeUp: 'Vaqt tugadi — javoblaringiz yuborilmoqda',
  retry: 'Qayta urinish',
  reloadApp: 'Qayta yuklash',
  openInTelegram: 'Ilovani Telegram ichida oching.',
  goHome: 'Bosh sahifa',
  nextBilet: 'Keyingi bilet',
  noWrongTitle: 'Xatolaringiz yo‘q',
  noWrongSub: 'Hali xato javob bermagansiz.',
  noQuestions: 'Savol topilmadi',
  authFail: 'Kirish imkonsiz',
  authFailBody: 'Aloqani tekshirib, qayta urinib ko‘ring.',
  updateTitle: 'Ilovani yangilang',
  updateBody:
    'Bu versiya endi ishlamaydi. Davom etish uchun Google Play’dan yangi versiyani o‘rnating.',
  updateCta: 'Google Play’da yangilash',
  guestTitle: 'Kirish kerak',
  guestBody: 'Saqlangan savollar, xatolar va javoblar tarixi hisobingizda saqlanadi.',
  guestProfile: 'Mehmon rejimi: natijalaringiz saqlanmaydi.',
  guestExamNote: 'Natija saqlanmadi. Saqlash uchun kiring.',
  appLoginBtn: 'Telegram orqali kirish',

  greet: 'Salom',
  biletlar: 'Biletlar',
  mavzular: 'Darslar',
  biletDoneSub: 'bilet yechilgan',
  biletNew: 'boshlanmagan',
  fAll: 'Hammasi',
  fWrong: 'Xatolar',
  fNew: 'Yangi',
  newTag: 'Yangi',
  left: 'bilet qoldi',
  practiceHead: 'Mashq',
  savolUnit: 'ta savol',
  pick: 'Javobni tanlang',
  resumeHead: 'Imtihon davom etmoqda',
  resumeSub: 'Qolgan vaqt',
  resumeCta: 'Davom ettirish',
  slipTitle: 'Imtihon bayonnomasi',
  stampOk: 'Sinov topshirildi',
  stampNo: 'Qayta topshiriladi',
  fLang: 'Til',
  fCat: 'Toifa',
  fDate: 'Sana / vaqt',
  fTime: 'Sarflandi',
  fErrors: 'Xatolar',
  rvMap: 'Javoblar xaritasi',
  rvWrong: 'Xatolar',
  rvAll: 'Barchasi',
  rvAllRight: 'Barcha javoblar to‘g‘ri',
  xato: 'xato',
  lessonRead: 'o‘qilgan',
  lessonMarkRead: 'O‘qidim',
  practiceThisTopic: 'Shu mavzuni mashq qilish',
  noLessons: 'Darslar topilmadi',
  noLessonsSub: 'Darslar hozircha mavjud emas.',
  belgilar: 'Belgilar',
  signUnit: 'ta belgi',
  kutubxona: 'Kutubxona',
  kutubxonaSub: 'Darslar, belgilar, shpargalkalar va ma’lumotnoma',
  topicUnit: 'ta dars',
  allCats: 'Barchasi',
  noSigns: 'Belgilar topilmadi',
  noSignsSub: 'Belgilar hozircha mavjud emas.',
  noArt: 'Rasm kutilmoqda',
  officialText: 'Rasmiy matn',
  ptr: 'Yangilanmoqda',
  peekHint: 'Qo‘yib yuborsangiz — yopiladi',
  drillTopic: 'Shu mavzuni mashq qilish',
  signSearch: 'Qidirish — nom yoki kod',
  recentSigns: 'Yaqinda ko‘rilgan',
  savedSigns: 'Saqlangan belgilar',
  noResults: 'Hech narsa topilmadi',
  noResultsSub: 'Boshqa so‘z yoki kod bilan urinib ko‘ring.',
  badgeB1: 'Birinchi bilet',
  badgeB10: '10 ta bilet',
  badgeB25: '25 ta bilet',
  badgeB35: 'Barcha biletlar',
  badgeE1: 'Birinchi imtihon',
  badgeE20: 'Toza 20/20',
  badgeT1: 'Mavzu 100%',
  badgeC50: 'Bank yarmi',
  awardEyebrow: 'Yangi nishon',
  awardNext: 'Keyingisi',
  awardDone: 'Natijaga qaytish',
  awardSub: {
    b1: 'Birinchi bilet yopildi — davom eting.',
    b10: '10 ta bilet yakunlandi.',
    b25: '25 ta bilet yakunlandi. Bank yarmiga yaqinsiz.',
    b35: 'Barcha biletlar yakunlandi.',
    s7: 'Yetti kun tanaffussiz.',
    s30: 'O‘ttiz kun tanaffussiz.',
    e1: 'Birinchi imtihon topshirildi.',
    e20: 'Yigirmadan yigirma — bitta ham xato yo‘q.',
    t1: 'Mavzu to‘liq o‘zlashtirildi.',
    c50: 'Savollar bankining yarmi ko‘rildi.',
  },
  settings: 'Sozlamalar',
  keepAwake: 'Ekran o‘chmasin',

  examSlipTitle: 'Nazariy imtihon',
  examSlipNote:
    'Boshlangandan keyin vaqt to‘xtamaydi. Ilovani yopsangiz, qaytib kelib davom ettirasiz. Savollar ketma-ket: ortga qaytib yoki o‘tkazib bo‘lmaydi.',
  slipQ: 'Savollar',
  slipTime: 'Vaqt',
  slipPass: 'O‘tish balli',
  slipErr: 'Ruxsat etilgan xato',
  cfHead: 'Imtihonni topshirasizmi?',
  cfBody: 'Topshirilgandan keyin javoblarni o‘zgartirib bo‘lmaydi.',
  cfLeft: 'Javobsiz savollar',
  cfBack: 'Imtihonga qaytish',
  cfSend: 'Baribir topshirish',
  themeLight: 'Yorug‘',
  themeSystem: 'Tizim',
  themeDark: 'Qorong‘i',
  rulesShort: 'Qoidalar',
  centersShort: 'Imtihon markazlari',
  tricky: 'Chalg‘ituvchi savollar',
  numeric: 'Raqamli savollar',
  noTrickySub:
    'Bu ro‘yxat ko‘pchilik xato qiladigan savollardan tuziladi — hozircha javoblar yetarli emas.',
  examLength: 'Savollar soni',
  qoidalar: 'Yo‘l harakati qoidalari',
  rulesSearch: 'Qoidalardan qidirish',
  rulesEmpty: 'Hech narsa topilmadi',
  rulesEmptySub: 'Boshqa so‘z bilan qidirib ko‘ring.',
  chapter: 'bob',
  chapterUnit: 'ta bob',
  centers: 'Imtihon markazlari',
  centerUnit: 'markaz',
  centersEmpty: 'Markazlar ro‘yxati hali yo‘q',
  cHours: 'Ish vaqti',
  cTransport: 'Qanday borish mumkin',
  cMap: 'Xaritada ochish',
  avtodrom: 'Avtodrom',
  avtodromSub: 'Amaliy imtihon mashqlari, bajarilish tartibida.',
  avtodromRowSub: 'Mashqlar va jarima ballari',
  mashqlar: 'Amaliy mashqlar',
  mashqlarTitle: '12 ta mashq',
  mashqlarSub: 'Avtodromda bajariladigan amaliy mashqlar',
  jarimalarTitle: 'Xatolik uchun jarima ballar',
  mashqList: [
    'Harakatni boshlash (START)',
    'Piyodalar o‘tish joyi',
    'To‘xtash va tik balandlikka ko‘tarilish (Estakada)',
    '90 gradus burchak ostida burilishlar',
    'Ilon izi',
    'Harakat tartibga solingan chorraha',
    'Tor joyda qayrilib olish uchun boksga kirish',
    'Temir yo‘l kesishmasi (tartibga solinmagan)',
    'Tezlashish bo‘lagi',
    'Avariya holatda to‘xtash',
    'Orqaga harakatlanib parallel to‘xtash (Parkovka)',
    'Harakatni yakunlash (FINISH)',
  ],
  penalties: 'Jarima ballari',
  pointsUnit: 'ball',
  severity: { minor: 'Kichik xato', medium: 'O‘rta xato', gross: 'Qo‘pol xato' },
  penaltiesSub: 'Kichik, o‘rta va qo‘pol xatoliklar',
  countUnit: 'ta',
  penaltyGroups: {
    minor: [
      { n: 1, p: 5, t: 'Xavfsizlik kamarini taqmadi' },
      { n: 2, p: 5, t: 'Chapga burilish chirog‘ini yoqmasdan «Start» chizig‘ini kesib o‘tdi' },
      {
        n: 3,
        p: 5,
        t: '«Start» chizig‘idan keyin 10 metr masofada chapga burilish chirog‘ini o‘chirmadi',
      },
      { n: 4, p: 5, t: '«To‘xtash chizig‘i»dan oldin 1 metrdan ko‘proq masofada to‘xtatdi' },
      { n: 5, p: 5, t: 'Tegishli yo‘nalishdagi burilish chirog‘ini yoqmadi' },
      { n: 6, p: 5, t: '4.7 va 3.24 yo‘l belgilarining talablarini buzdi' },
      {
        n: 7,
        p: 5,
        t: '«Harakatlanishni yakunlash (Finish)» chizig‘ini kesib o‘tishdan oldin o‘ngga burilish ishorasini yoqmadi',
      },
      {
        n: 8,
        p: 5,
        t: 'Harakatlanish tezligini 20 km/soatdan oshirib yubordi («Yo‘lning tezlashish qismida harakatlanish» mashqini bajarishdan tashqari)',
        note: 'har 5 soniya uchun',
      },
      {
        n: 9,
        p: 10,
        t: 'Svetoforning ruxsat beruvchi ishorasida chorrahadan o‘tish uchun 30 soniyadan ko‘p vaqt sarfladi',
      },
    ],
    medium: [
      { n: 10, p: 25, t: '«Start» ishorasidan keyin 30 soniya davomida harakatni boshlamadi' },
      { n: 11, p: 20, t: '«To‘xtash chizig‘i»ning oldida to‘xtamadi yoki uni bosib o‘tdi' },
      { n: 12, p: 20, t: 'To‘xtagandan so‘ng 3 soniya o‘tmasdan harakatni boshladi' },
      {
        n: 13,
        p: 25,
        t: '«Estakada» mashqida to‘xtagandan so‘ng 30 soniya davomida harakatni boshlamadi',
      },
      {
        n: 14,
        p: 20,
        t: '«Estakada» mashqida to‘xtagandan so‘ng yoki harakatni boshlashdan oldin transport vositasi orqaga 0,3 metrdan ortiq siljidi',
      },
      {
        n: 15,
        p: 20,
        t: '«90 gradus burilish» va «Ilon izi» mashqlarini bajarishda nazorat chizig‘ini bosdi',
      },
      {
        n: 16,
        p: 15,
        t: '«90 gradus burilish» va «Ilon izi» mashqlarini bajarishga 2 daqiqadan ko‘p vaqt sarfladi',
      },
      {
        n: 17,
        p: 20,
        t: '«Boksga kirish» va «Parallel to‘xtash» mashqlarida g‘ildiraklarni mashqni bajarishning qayd etish chizig‘iga qo‘ymadi',
      },
      {
        n: 18,
        p: 25,
        t: 'Yo‘lning tezlashish qismida harakatlanishda ikkinchi uzatmani qo‘shmadi',
      },
      {
        n: 19,
        p: 20,
        t: 'Transport vositasining salonida tovushli va/yoki yorug‘lik ishorasi yonganidan so‘ng 2 soniya ichida transport vositasini to‘xtatmadi',
      },
      {
        n: 20,
        p: 20,
        t: '«Avariya holatda to‘xtash» mashqida to‘xtagandan so‘ng 3 soniya ichida avariya ishorasini yoqmadi',
      },
      {
        n: 21,
        p: 10,
        t: '«Avariya holatda to‘xtash» mashqida harakatni boshlashdan oldin avariya ishorasini o‘chirmadi',
      },
      {
        n: 22,
        p: 20,
        t: 'Sinov mashqlarini bajarayotganda dvigatelni o‘chirib qo‘ydi',
        note: 'har bir xato uchun',
      },
    ],
    gross: [
      { n: 23, p: 100, t: '«Start» ishorasidan keyin 40 soniya davomida harakatni boshlamadi' },
      {
        n: 24,
        p: 100,
        t: 'Svetoforning taqiqlovchi ishorasida chorrahaga kirdi yoki transport vositasining eng oldingi nuqtasi «To‘xtash chizig‘i»dan o‘tdi',
      },
      { n: 25, p: 50, t: 'Temir yo‘l kesishmasidan to‘xtamasdan o‘tdi' },
      {
        n: 26,
        p: 100,
        t: 'Imtihonni o‘zboshimchalik bilan tark etdi yoki sinov mashqlarini bajarishni rad etdi',
      },
      { n: 27, p: 100, t: 'Sinov mashqlaridan birini bajarmadi' },
      {
        n: 28,
        p: 100,
        t: 'Sinov mashqlarini bajarish uchun belgilangan yo‘nalishdan chetga chiqib ketdi',
      },
      { n: 29, p: 100, t: 'Sinov mashqlarida ko‘zda tutilmagan joylarda orqaga harakatlandi' },
      {
        n: 30,
        p: 100,
        t: 'Boshqa transport vositasi bilan to‘qnashuv sodir qildi yoki to‘siqqa borib urildi',
      },
      { n: 31, p: 100, t: 'Harakatlanish tezligini 40 km/soatdan oshirib yubordi' },
      { n: 32, p: 100, t: 'Amaliy imtihon uchun belgilangan umumiy vaqtdan oshib ketdi' },
    ],
  } as PenaltyGroups,
  answerHistory: 'Javoblar tarixi',
  modePractice: 'Mashq',
  loadMore: 'Yana ko‘rsatish',
  report: 'Xato haqida xabar berish',
  reportHead: 'Savolda xato bormi?',
  reportComment: 'Qo‘shimcha ma’lumot (ixtiyoriy)',
  reportSend: 'Xabarni yuborish',
  reportThanks: 'Rahmat! Xabaringiz yuborildi. Savolni tekshirib, xato bo‘lsa tuzatamiz.',

  yourName: 'Ismingiz',
  yourSurname: 'Familiyangiz',

  drillShort: 'Xatolar',

  signOfDay: 'Kunning belgisi',
  signPrompt: 'Bu belgi nimani bildiradi? Eslab qolgansizmi?',
  signQuizPrompt: 'Bu qaysi belgi?',
  showAnswer: 'Javobni ko‘rsatish',
  knewIt: 'Bilardim',
  missedIt: 'Bilmadim',
  signKnewLog: 'Yaxshi — siz bu belgini bilasiz.',
  signMissLog: 'Saqlangan belgilarga qo‘shildi — Kutubxonadan qaytib ko‘rasiz.',

  fDone: 'O‘tilgan',
  biletEmpty: 'Bu bo‘limda bilet yo‘q',

  grpPractice: 'Mashq',
  resumeRow: 'Davom ettirish',
  resumeDrillSub: 'Tugallanmagan mashq',
  allTests: 'Barcha savollar',
  allTestsSub: 'Butun bank, tartib bilan',
  longSet: 'Random savollar bilan test',
  longSetSub: '50, 100, 200 yoki 500 ta savol',
  randomPick: 'Savol sonini tanlang',
  randomUnit: 'ta savol',
  randomHead: 'Random test · {n} {u}',
  byTopic: 'Mavzulashtirilgan savollar',
  byTopicSub: 'Har bir mavzu bo‘yicha alohida',
  drillSub: 'Siz adashgan savollar',
  savedSub: 'Belgilab qo‘yilgan savollar va belgilar',
  qSearch: 'Mavzu nomi bo‘yicha qidirish',
  sectionUnit: 'bo‘lim',
  qGroups: [
    {
      h: 'Yo‘l belgilari',
      topics: [
        { n: 31, h: 'Ogohlantiruvchi belgilar' },
        { n: 32, h: 'Imtiyoz belgilari' },
        { n: 33, h: 'Taqiqlovchi belgilar' },
        { n: 34, h: 'Buyuruvchi belgilar' },
        { n: 35, h: 'Axborot-ko‘rsatkich belgilari' },
        { n: 36, h: 'Servis belgilari' },
        { n: 37, h: 'Qo‘shimcha axborot belgilari' },
      ],
    },
    {
      h: 'Chorrahalar',
      topics: [
        { n: 13, h: 'Chorrahalarda harakatlanish' },
        { n: 14, h: 'Tartibga solingan chorrahalar' },
        { n: 16, h: 'Tartibga solinmagan teng ahamiyatli chorrahalar' },
        { n: 15, h: 'Tartibga solinmagan chorrahalar (asosiy yo‘l to‘g‘ri yo‘nalishda)' },
        { n: 17, h: 'Tartibga solinmagan chorrahalar (asosiy yo‘l yo‘nalishi o‘zgarishi)' },
      ],
    },
    {
      h: 'Ishoralar va chiziqlar',
      topics: [
        { n: 5, h: 'Svetofor ishoralari' },
        { n: 6, h: 'Tartibga soluvchining ishoralari' },
        { n: 7, h: 'Ogohlantiruvchi va avariya ishoralari' },
        { n: 38, h: 'Yotiq chiziqlar' },
        { n: 39, h: 'Tik chiziqlar' },
      ],
    },
    {
      h: 'Asosiy manevrlar',
      topics: [
        { n: 8, h: 'Harakatlanishni boshlash, manevr qilish' },
        { n: 9, h: 'Yo‘lning qatnov qismida transport vositalarining joylashuvi' },
        { n: 10, h: 'Harakatlanish tezligi' },
        { n: 11, h: 'Quvib o‘tish' },
        { n: 12, h: 'To‘xtash va to‘xtab turish' },
      ],
    },
    {
      h: 'Maxsus vaziyatlar',
      topics: [
        { n: 18, h: 'Piyodalar o‘tish joylari va yo‘nalishli transport vositalari bekatlari' },
        { n: 19, h: 'Temir yo‘l kesishmalari orqali harakatlanish' },
        { n: 20, h: 'Avtomagistrallarda harakatlanish' },
        { n: 21, h: 'Turar joy dahalarida harakatlanish' },
        { n: 22, h: 'Tik balandlik va nishabliklarda harakatlanish' },
        { n: 23, h: 'Yo‘nalishli transport vositalarining imtiyozlari' },
        { n: 4, h: 'Maxsus transport vositalarining imtiyozlari' },
        { n: 24, h: 'Tashqi yoritish asboblaridan foydalanish' },
      ],
    },
    {
      h: 'Umumiy qoidalar',
      topics: [
        { n: 1, h: 'Umumiy qoidalar' },
        { n: 2, h: 'Haydovchilarning umumiy vazifalari' },
        { n: 3, h: 'Piyodalarning umumiy vazifalari' },
      ],
    },
    {
      h: 'Maxsus holatlar va tashish',
      topics: [
        { n: 25, h: 'Mexanik transport vositalarini shatakka olish' },
        { n: 26, h: 'Transport vositalarini boshqarishni o‘rgatish' },
        { n: 27, h: 'Odam tashish' },
        { n: 28, h: 'Yuk tashish' },
        {
          n: 29,
          h: 'Velosiped, moped va aravalar harakatlanishiga hamda hayvonlarni haydab o‘tishga doir qo‘shimcha talablar',
        },
      ],
    },
    {
      h: 'Xavfsizlik va yakuniy',
      topics: [
        { n: 42, h: 'Birinchi tibbiy yordam' },
        { n: 41, h: 'Harakat xavfsizligi asoslari' },
        { n: 40, h: 'Transport vositalaridan foydalanishni taqiqlovchi shartlar' },
        { n: 30, h: 'Taniqli belgilar' },
      ],
    },
  ],

  sodToday: 'Bugungi belgi',
  sodKnew: 'Bilardim',
  sodRight: 'To‘g‘ri',
  sodMissed: 'Saqlandi',

  scanHead: 'Belgini suratga oling',
  scanSub: 'Mashina to‘xtab turganda belgini suratga oling — nomi va qoidasini aytadi',
  tutorHead: 'Ustoz — savol bering',
  tutorSub: '«Nega bu javob to‘g‘ri?» — sodda tilda tushuntiradi',
  pro: 'PRO',

  cheats: 'Shpargalkalar',
  cheatsHead: 'Imtihonda ko‘p uchraydigan, yodlash qiyin ma’lumotlar',
  cheatUnit: 'shpargalka',
  prevSheet: 'Oldingi',
  nextSheet: 'Keyingi',

  sizeRow: 'Matn va tugmalar o‘lchami',
  sizeSheetSub: 'Ekranlar va oynalardagi matn, tugmalar, kartochkalar bir xil nisbatda o‘zgaradi',
  sizes: {
    small: { h: 'Kichik', s: 'Ekranga ko‘proq sig‘adi' },
    std: { h: 'Standart', s: 'Odatiy o‘lcham' },
    large: { h: 'Katta', s: 'Kattaroq matn va tugmalar, o‘qish oson' },
  },

  grpTarif: 'Tarifingiz',
  tarifCurrent: 'joriy',
  tarifArt: 'Tarif rasmi',
  tarifUpgrade: 'Trassa’ga o‘tish',
  phoneRow: 'Telefon raqami',
  addAction: 'Qo‘shish',
  phoneAddFailed: 'Saqlab bo‘lmadi',
  phoneDeclined: 'Raqam ulashilmadi',
  phoneUnsupported: 'Telegram eski — bot orqali qo‘shing',
  phoneRemove: 'Raqamni o‘chirasizmi?',
  phoneRemoveBody: 'Raqam hisobingizdan o‘chiriladi. Uni botga qaytadan ulashsangiz bo‘ladi.',
  phoneRemoveConfirm: 'O‘chirish',
  phoneRemoveCancel: 'Bekor qilish',
  phoneRemoveFailed: 'O‘chirib bo‘lmadi',
  groupRow: 'Yopiq guruh',
  groupRowSub: 'Trassa tarifi bilan ochiladi',
  resetRow: 'Natijalarni o‘chirish',
  resetCancel: 'Bekor qilish',
  resetDone: 'Progress tozalandi',
  resetFailed: 'Tozalab bo‘lmadi',
  signOut: 'Chiqish',
  deleteAccount: 'Hisobni o‘chirish',
  grpGeneral: 'Umumiy',
  grpHelp: 'Yordam',
  langRow: 'Ilova tili',
  themeRow: 'Ko‘rinish',
  contactRow: 'Biz bilan bog‘lanish',
  privacyRow: 'Maxfiylik siyosati',
  editName: 'Ismni tahrirlash',
  copyId: 'ID nusxalash',
  unsupportedTitle: 'Ilova bu telefonda to‘liq ishlamaydi',
  unsupportedBody:
    'Telefoningizdagi brauzer komponenti eskirgan. Play Market’dan “Android System WebView” va Chrome’ni yangilang, so‘ng Telegram’ni qayta oching.',
  unsupportedAction: 'Yangilash',
  lessonMarked: 'Dars o‘qilgan deb belgilandi',
  streak: 'Bardavomlik',
  library: 'Yo‘l belgilari ma’lumotnomasi',
  signCount: 'ta belgi',
  bilet: 'Bilet',
  lsArt: 'Chizma',
  you: 'siz',
  comingSoon: 'tez kunda',
  display: 'Ko‘rinish',
  licNoName: 'kiritilmagan',
  greetGuest: 'haydovchi',
  slipTry: 'Urinish',
  spent: 'sarflandi',
  atEdge: 'chegarada',
  close: 'Yopish',
  diagTpl: '{n} ta xato · {m} tasi «{t}» mavzusida',
  diagTplOne: '{n} ta xato',
  rsHead: 'Barcha natijalar o‘chirilsinmi?',
  rsBody:
    'Yechilgan biletlar va xatolar o‘chadi. Tarifingiz, saqlangan savollar va imtihon natijalari qoladi. Buni qaytarib bo‘lmaydi.',
  rsGo: 'Natijalarni o‘chirish',
  rsBack: 'Bekor qilish',
  daHead: 'Hisobingiz o‘chirilsinmi?',
  daGo: 'Hisobni o‘chirish',
  appSub: 'Haydovchi',
  ordFirst: false,
  speedW: 'Tezlik',
  qNum: '{n}-savol',
  demoVideo: 'Namuna video',
  signArt: 'Belgi rasmi',
  backW: 'Orqaga',
  idCopyFail: 'Nusxalab bo‘lmadi — ID ni qo‘lda belgilang',
  planPick: 'Tarif tanlash',
  planUpShahar: 'Shahar’ga o‘tish',
  planExtend: 'Muddatni uzaytirish',
  planEnding: 'Tarif tugashiga {n} kun qoldi',
  phoneRefused: 'Ruxsat berilmadi',
  phoneNeed: 'Telefon raqami kerak',
  awakeNA: 'Qo‘llab-quvvatlanmaydi',
  examNoTries: 'Hali urinish yo‘q',
  signedOut: 'Hisobdan chiqdingiz',
  tarifUntil: 'Muddatsiz',
  planEndHead: 'Bepul Premium {n} {u}dan keyin tugaydi',
  planEndToday: 'Bepul Premium bugun tugaydi',
  planEndBody: 'Keyin ovozli izoh va boshqa Premium imkoniyatlari yopiladi.',
  planEndOk: 'Tushunarli',
  promoEmpty: 'Promokodni kiriting',
  promoBad: 'Bunday promokod yo‘q',
  promoUsed: 'Bu promokoddan foydalangansiz',
  planCurrent: 'Joriy tarif · uzaytiriladi',
  planLower: 'Joriy tarifingiz yuqoriroq — muddati tugagach tanlash mumkin',
  freeName: 'Bepul',
  daBodyNew:
    'So‘rov yuboriladi. Hisob {d} kun ichida o‘chiriladi — shu muddatda bekor qilishingiz mumkin.',
  daPending: 'O‘chirish so‘rovi yuborildi',
  daPendingSub: '{u} o‘chiriladi · bekor qilish',
  daCancelled: 'O‘chirish bekor qilindi',
  daSent: 'So‘rov yuborildi — hisob {d} kun ichida o‘chiriladi',
  bobUnit: 'bob',
  answerUnit: 'ta javob',
  rsnWrong: 'Belgilangan javob xato',
  rsnTypo: 'Matnda xato bor',
  rsnExplain: 'Izoh noto‘g‘ri yoki tushunarsiz',
  rsnImage: 'Rasm, video yoki ovoz ishlamaydi',
  rsnOther: 'Boshqa',
  sumMonth: 'so‘m / oy',
  offlineRow: 'Oflayn rejim',
  deleteAcc: 'Hisobni o‘chirish',
  langName: 'O‘zbekcha',
  notifRow: 'Bildirishnomalar',
  onWord: 'Yoniq',
  offWord: 'O‘chiq',
  trickyRow: 'Chalg‘ituvchi savollar',
  trickyRowSub: 'Ko‘pchilik adashadigan savollar',
  numericRow: 'Raqamli savollar',
  numericRowSub: 'Masofa, tezlik va muddatlar',
  cheatEmpty: 'Jadval tayyorlanmoqda — raqamlar tasdiqlangach qo‘shiladi.',
  exp: {
    ago: '{n} {u} oldin',
    uMin: 'daqiqa',
    uHour: 'soat',
    uDay: 'kun',
    yesterday: 'kecha',
    tabText: 'Izoh',
    tabVideo: 'Video',
    tabTalk: 'Muhokama',
    voice: 'Ovozli izoh',
    voiceLocked: 'O‘qituvchi ovozida tinglash — {p} tarifida',
    proGo: '{p} tarifiga o‘tish',
    listened: 'Tinglandi ✓',
    loading: 'Yuklanmoqda…',
    videoLocked: 'Video dars — {p} tarifida',
    chapters: 'Bo‘limlar',
    teacher: 'O‘qituvchi',
    proBanner: 'Ovozli izohlar — {a} tarifida, video darslar va AI — {v} tarifida.',
    emptyHead: 'Hali muhokama yo‘q',
    emptyBody: 'Birinchi bo‘ling — savolingiz yoki maslahatingiz boshqalarga yordam beradi.',
    modNote: 'Havola, @nom va reklama chiqmaydi. O‘qituvchi javobi yuqorida turadi.',
    composerPh: 'Fikr yozing…',
    you: 'Siz',
    like: 'Foydali',
    send: 'Yuborish',
    pending: 'Tekshirilmoqda',
    sendFail: 'Yuborilmadi. Qayta urinib ko‘ring.',
    retry: 'Qayta',
    limit: 'belgi qoldi',
    stop: 'Pauza va yashirish',
    offline: 'Internet yo‘q. Matnli izohlar ishlaydi; video va ovoz — ulanish tiklangach.',
    sending: 'Yuborilmoqda…',
    saved: 'Saqlandi',
    unsaved: 'Saqlanganlardan olindi',
    undo: 'Bekor qilish',
    checked: 'Tekshirildi ✓',
    nameSaved: 'Saqlandi ✓',
    slow: 'Ulanish sekin. Kutib turamiz…',
    vidTitle: 'Chorrahada ustunlik — qoidaning to‘liq tartibi',
    chapList: [
      ['0:00', 'Qoida qachon ishlaydi'],
      ['0:52', 'Belgilar ustunligi'],
      ['1:35', 'Imtihonda tuzoq savollar'],
    ],
    cmts: [
      [
        'Dilshod Ahmedov',
        'O‘qituvchi',
        'D',
        '2 kun oldin',
        34,
        'Eng ko‘p adashiladigan joy shu: belgi bo‘lsa — belgi ustun, faqat belgi bo‘lmaganda o‘ng qo‘l qoidasi ishlaydi.',
      ],
      [
        'Nodira Q.',
        '',
        'N',
        'kecha',
        12,
        'Shu izohni tinglaganimdan keyin bu turdagi savollarda adashmayapman.',
      ],
    ],
    freeName: 'Bepul',
    cbSent: 'So‘rov yuborildi — mutaxassis tez orada bog‘lanadi',
    leaveH: 'Imtihondan chiqasizmi?',
    leaveBGuest: 'Vaqt to‘xtamaydi. Mehmon rejimida chiqsangiz, bu urinishga qaytib bo‘lmaydi.',
    leaveB:
      'Vaqt to‘xtamaydi. Javoblaringiz saqlanadi — vaqt tugamasdan qaytib davom ettirishingiz mumkin.',
    leaveStay: 'Imtihonda qolish',
    leaveGo: 'Chiqish',
    elseH: 'Imtihon boshqa qurilmada ochiq',
    elseB:
      'Bir vaqtda faqat bitta qurilmada topshirish mumkin. Uni o‘sha yerda yakunlang yoki vaqt tugashini kuting.',
    refreshed: 'Ma’lumotlar yangilandi',
    nameWarn: 'Faqat harflar, apostrof va chiziqcha',
    resetDone: 'Natijalar o‘chirildi',
    undo2: 'Qaytarish',
    blockH: 'Hisobingiz cheklangan',
    blockB:
      'Qoidalar buzilgani sababli hisob vaqtincha cheklandi. Batafsil bilish uchun botga yozing — javob beramiz.',
    blockGo: 'Botga yozish',
    notifOff: 'O‘chirilgan',
    notifHow:
      'Bildirishnomalar Telegram’da o‘chirilgan. Telegram → Sozlamalar → Bildirishnomalar orqali yoqing.',
    histEmptyH: 'Hali javob yo‘q',
    histEmptyB: 'Birinchi biletni yeching — har bir javobingiz shu yerda saqlanadi.',
    imgFail: 'Rasm yuklanmadi',
    audioFail: 'Ovoz yuklanmadi. Internetni tekshirib, qayta urinib ko‘ring.',
    queued: 'Internet qaytganda yuboriladi',
    queuedShort: 'internet qaytganda yuboriladi',
    backOnline: 'Internet qaytdi',
    backOnlineN: 'Internet qaytdi · {n} ta o‘zgarish yuborildi',
    moreCmts: 'Yana ko‘rsatish ({n})',
    endCmts: 'Boshqa fikr yo‘q',
    sessH: 'Sessiya tugadi',
    sessB:
      'Xavfsizlik uchun kirish muddati tugadi. Ilovani qayta oching — natijalaringiz saqlangan.',
    sessGo: 'Qayta ochish',
    scanTitle: 'Belgi skaneri',
    scanHint: 'Belgini ramkaga joylang. Faqat mashina to‘xtab turganda suratga oling.',
    scanCam: 'Kamera',
    scanShoot: 'Suratga olish',
    scanBusy: 'Aniqlanmoqda…',
    scanNoneH: 'Belgi aniqlanmadi',
    scanNoneB: 'Yaqinroqdan, yorug‘ joyda va belgi to‘liq ko‘rinadigan qilib qayta suratga oling.',
    scanAgain: 'Qayta suratga olish',
    scanFoundH: 'Belgi aniqlandi',
    scanFoundB: 'Belgi nomi va qoidasi shu yerda ko‘rsatiladi.',
    camDeniedH: 'Kameraga ruxsat berilmagan',
    camDeniedB: 'Telefon sozlamalarida Telegram uchun kamerani yoqing, so‘ng qayta urining.',
    camRetry: 'Qayta urinish',
    examFail:
      'Natija yuborilmadi. Javoblaringiz saqlangan — internetni tekshirib, qayta urinib ko‘ring.',
    timeUp: 'Imtihon vaqti tugadi — javoblaringiz yuborildi.',
    cLabel: 'Fikringiz',
    vidFail: 'Video yuklanmadi. Internetni tekshirib, qayta urinib ko‘ring.',
    rejected: 'Chiqarilmadi',
    rejNote: 'Havola va reklama mumkin emas. Matnni o‘zgartirib, qayta yozing.',
    cmtDelete: 'O‘chirish',
    cmtReport: 'Shikoyat',
    cmtReported: 'Shikoyat yuborildi',
    guestCmt: 'Fikr yozish uchun hisobingizga kiring.',
    sheetHead: 'Javob izohi',
    swipeTip: 'Savollar orasida o‘tish uchun chapga yoki o‘ngga suring',
    resHead: 'Bilet yakunlandi',
    resScore: '{c} / {n}',
    resPass: 'Imtihon me’yori bajarildi — 18 ta yoki undan ko‘p to‘g‘ri.',
    resFail: 'Imtihonda kamida 18 ta to‘g‘ri javob kerak.',
    resAgain: 'Yana {n} {u}',
    resHome: 'Bosh sahifaga',
    gapHead: '{n} ta savol javobsiz qoldi',
    gapBody: 'Javobsiz savollar noto‘g‘ri deb hisoblanadi.',
    gapGo: 'Javob berish',
    gapFinish: 'Baribir yakunlash',
    netErr: 'Saqlanmadi. Internetni tekshirib, qayta urinib ko‘ring.',
  },
  pw: {
    head: 'Tarifni tanlang',
    sub: 'Savollar va matnli izohlar hamma uchun bepul.',
    ai: 'AI Ustoz va Belgi skaneri',
    terms:
      'Bir martalik to‘lov, 1 oyga. O‘zi uzaytirilmaydi — kartangizdan pul avtomatik yechilmaydi.',
    cta: '{p} tarifini tanlash',
  },
};

export type Strings = typeof uzl;

export type TextKey = {
  [K in keyof Strings]: Strings[K] extends string ? K : never;
}[keyof Strings];

const registry: Partial<Record<Lang, Strings>> = { uzl };

export const STR = registry as Record<Lang, Strings>;

const loaders: Record<Exclude<Lang, 'uzl'>, () => Promise<Strings>> = {
  uzk: () => import('@/strings/uzk').then((m) => m.uzk),
  ru: () => import('@/strings/ru').then((m) => m.ru),
};

const inflight = new Map<Lang, Promise<Strings>>();

export function hasStrings(lang: Lang): boolean {
  return registry[lang] !== undefined;
}

export function loadStrings(lang: Lang): Promise<Strings> {
  const ready = registry[lang];
  if (ready) return Promise.resolve(ready);
  const pending = inflight.get(lang);
  if (pending) return pending;
  const flight = loaders[lang as Exclude<Lang, 'uzl'>]().then(
    (strings) => {
      registry[lang] = strings;
      inflight.delete(lang);
      return strings;
    },
    (e: unknown) => {
      inflight.delete(lang);
      throw e;
    },
  );
  inflight.set(lang, flight);
  return flight;
}

export function warmStrings(): void {
  for (const lang of Object.keys(loaders) as Lang[]) void loadStrings(lang).catch(() => {});
}

export function topicName(topic: number, t: Strings): string {
  const named = t.qGroups.flatMap((g) => g.topics).find((item) => item.n === topic);
  return named ? named.h : `${t.topic} ${topic}`;
}

export function biletLabel(n: number, lang: Lang): string {
  if (lang === 'ru') return `Билет ${n}`;
  return `${n}-${lang === 'uzk' ? 'билет' : 'bilet'}`;
}

const RU_PLURAL = new Intl.PluralRules('ru');

export function plural(n: number, unit: string): string {
  const forms = unit.split('|');
  if (forms.length === 1) return unit;
  const rule = RU_PLURAL.select(n);
  return forms[rule === 'one' ? 0 : rule === 'few' ? 1 : 2];
}

export function useT(): Strings {
  return registry[useLang().lang] ?? uzl;
}
